// Mandatory ticket assignees (the planning team).
//
// The backend flags a company's planning department(s) with `mandatory: true`
// in the /assignable-users payload. Those departments are assigned to EVERY
// ticket automatically and can never be removed (enforced server-side in
// generate_ticket / update_assignees). The assignee pickers use these helpers
// to render them as locked chips and to keep them in the selection no matter
// what the user does (chip delete, backspace, or unchecking in the dropdown).

// Set of department ids that are mandatory, derived from the assignable list.
export const mandatoryDeptIdSet = (assignable = []) =>
  new Set(assignable.filter((d) => d && d.mandatory).map((d) => d.id));

// Merge a desired selection with the mandatory departments, deduped by id, so a
// mandatory department is always present. `selected` objects may not carry the
// `mandatory` flag (e.g. they came from a ticket's saved assignees), so the
// mandatory set is always sourced from `assignable`.
export const withMandatoryDepartments = (selected = [], assignable = []) => {
  const byId = new Map();
  selected.forEach((d) => {
    if (d && d.id != null) byId.set(d.id, d);
  });
  assignable
    .filter((d) => d && d.mandatory)
    .forEach((d) => byId.set(d.id, d));
  return Array.from(byId.values());
};
